import { render, staticRenderFns } from "./vacancy-admin.vue?vue&type=template&id=dbc42c9c&"
import script from "./vacancy-admin.vue?vue&type=script&lang=js&"
export * from "./vacancy-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbc42c9c')) {
      api.createRecord('dbc42c9c', component.options)
    } else {
      api.reload('dbc42c9c', component.options)
    }
    module.hot.accept("./vacancy-admin.vue?vue&type=template&id=dbc42c9c&", function () {
      api.rerender('dbc42c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/vacancies/vacancy-admin.vue"
export default component.exports